module.exports = __webpack_public_path__ + "3e0b6f876be28df2f710d24c4ce55d69.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarityScale/flawless@2x.png
// module id = 816
// module chunks = 0